import { render, staticRenderFns } from "./liveForm.vue?vue&type=template&id=0f237368&scoped=true"
import script from "./liveForm.vue?vue&type=script&lang=js"
export * from "./liveForm.vue?vue&type=script&lang=js"
import style0 from "./liveForm.vue?vue&type=style&index=0&id=0f237368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f237368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f237368')) {
      api.createRecord('0f237368', component.options)
    } else {
      api.reload('0f237368', component.options)
    }
    module.hot.accept("./liveForm.vue?vue&type=template&id=0f237368&scoped=true", function () {
      api.rerender('0f237368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/appCard/components/liveForm.vue"
export default component.exports